import BuoyClient from 'lib/BuoyClient';

import localForage from 'localforage';

import { FormValues } from 'types';

export const postArticleRating = (slug: string, isUpvote: boolean) => {
  return {
    type: 'POST_ARTICLE_RATING',
    payload: new Promise((resolve, reject) => {
      localForage.getItem(`article_rating_${slug}`, (err, value) => {
        if (err) {
          console.error(err);
          return reject(err);
        }

        if (!value) {
          BuoyClient.postArticleRating(slug, isUpvote)
            .then((data) => {
              localForage.setItem(`article_rating_${slug}`, isUpvote, (err) => {
                if (err) {
                  console.error(err);
                  return reject(err);
                }

                return resolve(data);
              });
            })
            .catch(reject);
        }
      });
    }),
  };
};

export const postArticleUserStory = (
  slug: string,
  id: string,
  formValues: FormValues
) => {
  return {
    type: 'POST_ARTICLE_USER_STORY',
    payload: BuoyClient.postArticleUserStory(slug, id, formValues),
  };
};
